// 设置 Get 参数
export async function setQuery(id, value) {
    let query = { ...this.$route.query };
    query[id] = value;
    await this.$router.push({ query });
}

// 加载列表数据（支持分页）
export async function loadList(descending, andQuery, onlySelf, options = {}) {
    const { append = false, limit = 20, skip = 0 } = options;
    
    let query;
    if (andQuery) {
        // 如果传入了预设的 query，直接使用它
        query = andQuery;
    } else {
        query = new this.$lc.Query(this.targetName);
    }
    
    if (onlySelf && this.$user) {
        query.equalTo("userId", this.$user.get('objectId'));
    }
    if (this.keyword) {
        query.contains(this.searchFile, this.keyword)
    }
    descending = descending || "createdAt"
    query.descending(descending);
    query.limit(limit);
    query.skip(skip);
    
    let data = await query.find();
    const newItems = data.map((item) => {
      return {
        item,
        ...item.attributes,
        id: item.id,
      };
    });
    
    if (append) {
        this.dataSource = [...this.dataSource, ...newItems];
    } else {
        this.dataSource = newItems;
    }
    
    return newItems.length;
}

export async function loadDetail() {
    let id = this.$route.query.id;
    if (id) {
      this.target = await new this.$lc.Query(this.targetName)
        .equalTo("objectId", id)
        .first();
      this.formState = { ...this.target.attributes };
      this.defaultState = { ...this.target.attributes };
    } else {
      this.target = new this.$lc.Object(this.targetName);
    }
    return id
}

// 新增
export async function add(query, targetName) {
    query = query || {}
    targetName = targetName || this.targetName || ''
    this.$router.push({
        path: `/${targetName}/add`,
        query
    })
}

// 删除
export async function del(id, isDetail, targetName) {
    console.log('====', id, isDetail, this.targetName)
    targetName = targetName || this.targetName || ''
    let res = await new this.$lc.Query(targetName)
        .equalTo("objectId", id)
        .first();
    console.log(res)
    await res.destroy();
    this.$message.info(`删除成功`);
    if (isDetail) {
      this.$router.back();
    } else {
        this.init();
    }
}

// 搜索
export async function search(keyword) {
    await this.$setQuery("keyword", keyword);
    this.init();
}

// 详情
export async function detail(id, targetName) {
    targetName = targetName || this.targetName || ''
    this.$router.push({
        path: `/${targetName}/detail`,
        query: {
            id
        }
    });
}

// 重置
export function reset(defaultState) {
  this.formState = { ...defaultState };
}

// 提交数据
export async function confirm(target, formStates) {
    for (const key in formStates) {
        await target.set(key, formStates[key]);
    }
    if (!target.get('userId')) {
      let userId = this.$user.get("objectId");
      await target.set('userId', userId);
    }
    await target.save();
    this.$message.success("提交成功！");
    await this.$router.back();
}

// 格式化时间
export function dateFormat(fmt, date) {
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (let k in opt) {
        let ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}
